export { default } from "./ResponseTimeItem.component";
